import React, { useContext } from 'react';
import { Navigate, Outlet,} from 'react-router-dom';
import AuthContext from './AdminAuthContext';

const AdminRoute = () => {
    const { isAdminAuthenticated } = useContext(AuthContext);
    return isAdminAuthenticated ? <Outlet /> : <Navigate to="/admin-signin" replace/>;
}

export default AdminRoute